
import { Component, Vue } from 'vue-property-decorator'
import ItemModal from '../../modules/ItemModal.vue'
import CheckoutModal from '../../modules/order/CheckoutModal.vue'
import CategoryHeader from '../../modules/headers/CategoryHeader.vue'
import UserDropdown from '../../modules/user/UserDropdown.vue'
import Cart from '../../modules/Cart.vue'
import SearchHeader from '../../modules/headers/SearchHeader.vue'
import UserModule from '../../modules/headers/UserModule.vue'
import LoginModal from '@/modules/user/LoginModal.vue'
import RegisterModal from '@/modules/user/RegisterModal.vue'
import { CategoriesStore } from '@/store/stores/CategoriesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)

@Component({
  components: {
    ItemModal,
    CheckoutModal,
    LoginModal,
    RegisterModal,
    UserModule,
    SearchHeader,
    Cart,
    UserDropdown,
    CategoryHeader,
  },
})
export default class categories extends Vue {
  categories: CategoriesStore = CategoriesStore.getInstance()
  envConfigurations: any = envConfiguration
  mysectorId: number = envConfiguration.sectorID
  breadcrumbs: Array<String> = ['Të gjitha']
  categoriesData: Array<any> = []
  history: Array<any> = []

  showSubcategories(category) {
    if (category.children.length != 0) {
      this.history.push(this.categoriesData)
      this.breadcrumbs.push(category.name)
      this.categoriesData = category.children
    }
  }
  goBack() {
    if (this.history.length > 0) {
      this.categoriesData = this.history.pop()
      this.breadcrumbs.pop()
    }
  }
  goToMain() {
    this.history = []
    this.breadcrumbs = ['Të gjitha']
    this.categoriesData = this.categories.getStore()
  }
  mounted() {
    this.categories.loadData(this.mysectorId, () => {
      this.categoriesData = this.categories.getStore()
    })
  }
}
